export const settlementTypeList = [
  { label: '固价', value: 0 },
  { label: '分成', value: 1 },
  { label: 'RTB竞价', value: 2 }
]

export const settlementTypeMap = {
  0: '固价',
  1: '分成',
  2: 'RTB竞价'
}